import {
  Box,
  Button,
  Flex,
  Icon,
  List,
  ListIcon,
  ListItem,
  Radio,
  Text,
  Tooltip,
  VStack,
} from "@chakra-ui/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FaAngleDown, FaAngleUp, FaStar } from "react-icons/fa";
import { useSelector } from "react-redux";
import { subscriptionFeaturesList } from "../../_components/details/constants";
import { currencyFormatter } from "../../_utils/currencyFormatter";

function TldrBillingPlansCardDetails({
  plan,
  activeSubscription,
  planIndex,
  yearlyInterval,
  currentOrg,
  adminMember,
  showSummary,
  selectedPlanId,
  setSelectedPlanId,
  notSelectable,
  updatingPlan,
  handlePaymentBySource,
}) {
  const { t } = useTranslation(["billing"]);
  const isMobileView = useSelector((state) => state.app.isMobileView);
  const subscription = useSelector((state) => state.subscription);
  const { subscribedPlan } = subscription;
  const [showPlanDetails, setShowPlanDetails] = useState(false);
  const { product, unit_amount } = plan;
  const isPlanActive =
    activeSubscription?.plan?.id === plan.id &&
    activeSubscription.status !== "trial";
  const basePrice = unit_amount / 100;

  return (
    <Box
      onClick={() =>
        showSummary && !notSelectable ? setSelectedPlanId(plan.id) : undefined
      }
      color="gray.100"
      backgroundColor={
        showSummary ? "brand.glass_light_10" : "brand.grey-darker"
      }
      border={showSummary ? "none" : "2px solid transparent"}
      cursor={showSummary && !notSelectable ? "pointer" : ""}
      sx={
        isPlanActive || selectedPlanId === plan.id
          ? { border: "2px solid #ffac41" }
          : {}
      }
      padding={showSummary ? "3" : "5"}
      flexBasis={0}
      flexGrow={1}
      borderRadius="lg"
    >
      {showSummary ? (
        <>
          <Flex justify="space-between" align="center">
            <Text
              fontSize={"xl"}
              fontWeight={500}
              color={"white"}
              textAlign={"left"}
            >
              {product.name}
            </Text>
            {notSelectable ? null : (
              <Radio
                name="select_plan"
                mt={2}
                size="lg"
                checked={selectedPlanId === plan.id}
                value={plan.id}
              />
            )}
          </Flex>
          <Flex
            flexDir={isMobileView ? "row" : "column"}
            justify={isMobileView ? "space-between" : "flex-start"}
          >
            <Text flex={1} textAlign={"left"} fontSize="sm" height={"6"} mb="4">
              {subscriptionFeaturesList[planIndex]?.context}
            </Text>
            <Box
              w={isMobileView ? "40" : "full"}
              display="flex"
              flexDir={isMobileView ? "column" : "row"}
              textAlign={"end"}
              gap={isMobileView ? 0 : 3}
            >
              <Text color="white" fontWeight={700} fontSize={"3xl"}>
                {!yearlyInterval
                  ? `${currencyFormatter(
                      basePrice,
                      subscription?.subscribedPlan?.plan?.currency
                    )}`
                  : `${currencyFormatter(
                      basePrice / 12,
                      subscription?.subscribedPlan?.plan?.currency
                    )}`}
              </Text>
              <Text
                textAlign={isMobileView ? "" : "start"}
                fontSize="sm"
                fontWeight={isMobileView ? "normal" : "500"}
              >
                {t("billingcard.permonthmembers")}
              </Text>
            </Box>
          </Flex>
        </>
      ) : (
        <>
          <Text
            fontSize={isMobileView ? "xl" : "2xl"}
            fontWeight={500}
            color={subscriptionFeaturesList[planIndex]?.color}
            textAlign={isMobileView ? "left" : "center"}
          >
            {product.name}
          </Text>
          <Text
            textAlign={isMobileView ? "left" : "center"}
            fontSize="sm"
            mb="4"
          >
            {subscriptionFeaturesList[planIndex]?.context}
          </Text>

          <Flex flexDirection="column" w="full">
            <Flex
              justify={isMobileView ? "space-between" : "center"}
              align="center"
            >
              <>
                <Box
                  h={isMobileView ? "auto" : "90px"}
                  maxHeight="90px"
                  fontSize={isMobileView ? "md" : "5xl"}
                  fontWeight={isMobileView ? "500" : ""}
                  color={subscriptionFeaturesList[planIndex]?.color}
                >
                  {!yearlyInterval
                    ? `${currencyFormatter(
                        basePrice,
                        subscription?.subscribedPlan?.plan?.currency
                      )}`
                    : `${currencyFormatter(
                        basePrice / 12,
                        subscription?.subscribedPlan?.plan?.currency
                      )}`}
                  {isMobileView ? (
                    <Text as="span" fontWeight={400}>
                      {" "}
                      / {t("billingcard.month")}
                    </Text>
                  ) : (
                    <Text
                      fontSize={"sm"}
                      textAlign="center"
                      color={"gray.100"}
                      as="p"
                    >
                      {t("billingcard.permonth")}
                    </Text>
                  )}
                </Box>
                {isMobileView && (
                  <Flex
                    align="center"
                    onClick={() => {
                      setShowPlanDetails(!showPlanDetails);
                    }}
                  >
                    <Text
                      as="span"
                      sx={isMobileView ? { fontSize: "md" } : null}
                    >
                      {t("billingcard.details")}
                    </Text>
                    <Icon
                      sx={
                        isMobileView
                          ? { fontSize: "md", marginLeft: "8px" }
                          : null
                      }
                      as={showPlanDetails ? FaAngleUp : FaAngleDown}
                    />
                  </Flex>
                )}
              </>
            </Flex>
            <VStack align="center" w="full">
              <>
                <Text
                  alignSelf={isMobileView ? "start" : "center"}
                  as="p"
                  mb="1"
                  fontSize="sm"
                >
                  {parseInt(basePrice) === 0
                    ? t("billngcard.tooltip.free")
                    : t("billingcard.upto")}
                </Text>
                {isPlanActive ? (
                  <Text
                    as="span"
                    mt={3}
                    mb={1}
                    display="flex"
                    alignItems="center"
                    justifyContent={"center"}
                    backgroundColor={isMobileView ? "brand.border-color" : null}
                    height={isMobileView ? "45px" : "90px"}
                    borderRadius="lg"
                    width={isMobileView ? "100%" : "90%"}
                  >
                    {t("billingcard.currentplan")}
                  </Text>
                ) : parseInt(basePrice) === 0 &&
                  currentOrg?.members_count > 1 ? (
                  <>
                    <Tooltip label={t("billingcard.tooltip")} hasArrow>
                      <Box w="full">
                        <Button
                          isLoading={updatingPlan}
                          loadingText={t("billingcard.wait")}
                          mt={3}
                          mb={1}
                          variant="outline"
                          width={isMobileView ? "100%" : "90%"}
                          key="add"
                          onClick={() => {
                            handlePaymentBySource(plan);
                          }}
                          disabled={
                            updatingPlan ||
                            (parseInt(basePrice) === 0 &&
                              currentOrg?.members_count > 1) ||
                            (!adminMember?.is_admin && !adminMember?.is_primary)
                          }
                        >
                          {parseInt(subscribedPlan?.plan?.amount) > basePrice
                            ? t("billingcard.downgrade")
                            : t("billingcard.upgrade")}
                        </Button>
                      </Box>
                    </Tooltip>
                  </>
                ) : !adminMember?.is_admin && !adminMember?.is_primary ? (
                  <>
                    <Tooltip label={t("billingcard.tooltip.owner")} hasArrow>
                      <Button
                        isLoading={updatingPlan}
                        loadingText={t("billingcard.wait")}
                        mt={3}
                        mb={1}
                        variant="outline"
                        width={isMobileView ? "100%" : "90%"}
                        key="add"
                        onClick={() => {
                          handlePaymentBySource(plan);
                        }}
                        disabled={
                          updatingPlan ||
                          (parseInt(basePrice) === 0 &&
                            currentOrg?.members_count > 1) ||
                          (!adminMember?.is_admin && !adminMember?.is_primary)
                        }
                      >
                        {parseInt(subscribedPlan?.plan?.amount) > basePrice
                          ? t("billingcard.downgrade")
                          : t("billingcard.upgrade")}
                      </Button>
                    </Tooltip>
                  </>
                ) : (
                  <>
                    <Button
                      isLoading={updatingPlan}
                      loadingText={t("billingcard.wait")}
                      mt={3}
                      mb={1}
                      variant="outline"
                      width={isMobileView ? "100%" : "90%"}
                      key="add"
                      onClick={() => {
                        handlePaymentBySource(plan);
                      }}
                      disabled={
                        updatingPlan ||
                        (parseInt(basePrice) === 0 &&
                          currentOrg?.members_count > 1) ||
                        (!adminMember?.is_admin && !adminMember?.is_primary)
                      }
                    >
                      {parseInt(subscribedPlan?.plan?.amount) > basePrice
                        ? t("billingcard.downgrade")
                        : t("billingcard.upgrade")}
                    </Button>
                  </>
                )}
              </>
            </VStack>
          </Flex>

          {(showPlanDetails || !isMobileView) && (
            <>
              <hr className="tldr-hl" />
              <Text
                textAlign={isMobileView ? "left" : "center"}
                as="p"
                mb="unset"
                fontWeight={500}
                fontSize="lg"
              >
                {subscriptionFeaturesList[planIndex]?.additional_feature}
              </Text>
              <VStack align="center" justify="space-between" w="full" mt="4">
                <List w="full">
                  {subscriptionFeaturesList[planIndex]?.features.map(
                    (feature, index) => {
                      return (
                        <ListItem display="flex" mb="2" key={index}>
                          <ListIcon
                            mt="1"
                            as={FaStar}
                            color={subscriptionFeaturesList[planIndex]?.color}
                          />
                          {feature}
                        </ListItem>
                      );
                    }
                  )}
                </List>
              </VStack>
            </>
          )}
        </>
      )}
    </Box>
  );
}

export default TldrBillingPlansCardDetails;
